import {mapGetters} from 'vuex'
import {getName} from '@/utils/disaster'

export default {
  name: 'DisastersSection',
  computed: {
    ...mapGetters('Dashboard', ['disasters']),
  },
  methods: {
    startTime (i) {
      const str = new Date(i.time.start).toGMTString()
      return str.slice(0, -7)
    },
    disasterName (i) {
      return getName(i.type)
    }
  }
}